import { computed, defineComponent, reactive } from 'vue';
import moment from 'moment';
import { useModelWrapper, DateHelper } from '@hems/util';
import VCalendarWrapper from './VCalendarWrapper.vue';
export default defineComponent({
    name: 'VCalendarRange',
    components: {
        VCalendarWrapper,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        langCd: {
            type: String,
            default: 'en',
        },
        label: {
            type: String,
            default: null,
        },
        format: {
            type: String,
            default: null,
        },
        mode: {
            type: String,
            default: null,
        },
        minDate: Date,
        maxDate: Date,
        validate: Function,
    },
    setup(props, { emit }) {
        const state = reactive({
            open: false,
            value: useModelWrapper(props, emit),
            dateMode: computed(() => (props.mode ? props.mode : 'datetime')),
        });
        const displayValueStart = computed(() => props.format
            ? moment(state.value.start).format(props.format)
            : DateHelper.getDateFormatter(props.langCd, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            })
                .format(state.value.start)
                .toString());
        const displayValueEnd = computed(() => props.format
            ? moment(state.value.end).format(props.format)
            : DateHelper.getDateFormatter(props.langCd, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            })
                .format(state.value.end)
                .toString());
        return {
            state,
            displayValueStart,
            displayValueEnd,
            onOpen: () => (state.open = true),
            onClose: () => (state.open = false),
        };
    },
});
